module.exports = __webpack_public_path__ + "static/GT-Super-Text-Book-09921fbcdb0ca88690a61a24c383be4e.woff2";